"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ForgotPasswordPage = void 0;
const mithril_1 = __importDefault(require("mithril"));
const app_1 = require("../../app");
const alert_box_1 = require("../../widgets/alert_box");
const form_for_1 = require("../../widgets/form_for");
let status = "idle";
const formParams = {
    email: ""
};
function checkPasswordAndUpdate(evt) {
    evt.preventDefault();
    app_1.App.patch("/password/forgot", {
        email: formParams.email,
    }).then((x) => {
        status = x.status;
    }).catch((_err) => {
        status = "error";
    });
}
function renderForm() {
    return (0, mithril_1.default)(".content", (0, mithril_1.default)("h2", "J'ai oublié mon mot de passe"), (status == "error" ? (0, alert_box_1.alertBox)({ content: "Erreur imprévue du serveur. Veuillez rééssayer dans quelques minutes", level: "danger" }) : undefined), (status == "not-found" ? (0, alert_box_1.alertBox)({ content: "L'adresse e-mail renseignée n'existe pas dans notre base de donnée", level: "warning" }) : undefined), (0, mithril_1.default)("p", "Une procédure pour accéder à votre compte vous sera partagé par e-mail"), (0, mithril_1.default)("form", (0, form_for_1.field)("Votre adresse e-mail", "email", "email", formParams, { placeholder: "votre@email.com" }), (0, mithril_1.default)("button.button.is-success", { type: "submit", onclick: (evt) => { checkPasswordAndUpdate(evt); } }, "Suivant")));
}
function renderOk() {
    return (0, mithril_1.default)("div", "Un e-mail avec les instructions pour récupérer votre compte vous a été envoyé", (0, mithril_1.default)("br"), (0, mithril_1.default)("a", { href: "/" }, "Retourner à la page de connexion"));
}
exports.ForgotPasswordPage = {
    view() {
        return (0, mithril_1.default)(".sign-in", { style: "padding-top: 5em;" }, (0, mithril_1.default)("nav.panel.container", { style: "background-color: white; padding: 1.5em; border-radius: 5px; max-width: 480px;" }, (status == "ok" ? renderOk() : renderForm())));
    }
};
